/**
 * The avatar monogram for a name, as the designs show it: the initial of each of the first two
 * words ("Greystar Central" -> "GC"). A single-word name falls back to its first two characters so
 * every tile is two letters wide and rows stay aligned.
 *
 * Shared by the organization picker, the sidebar switcher and the community header — the same
 * subject shows up side by side across a navigation, so a monogram that differed between surfaces
 * would read as two different accounts.
 */
export const getNameInitials = (name) => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0)
        return "";
    if (words.length === 1)
        return words[0].slice(0, 2).toUpperCase();
    return `${words[0][0]}${words[1][0]}`.toUpperCase();
};
